import { IOpObject, IReferenceType, IOpChangeState } from '../util/interfaces'
import { Enums } from '../common/enums'
import { Utils } from '../util/utils'
import { ObjectCustomString } from '../../models/util/object-custom-string'

import { OpAlarmType } from '../core/op-alarm-type'
import { OpAlarmStatus } from '../core/op-alarm-status'
import { OpDataList } from '../util/op-data-list'
import { OpDataType } from '../core/op-data-type'
import { OpDescr } from '../core/op-descr'
import { OpDevice } from '../core/op-device'
import { OpLocation } from '../core/op-location'
import { OpMeter } from '../core/op-meter'
import { OpOperator } from '../core/op-operator'
import { OpTransmissionType } from '../core/op-transmission-type'

import { OpAlarmMessage } from '../dw/op-alarm-message'

import { OpAlarmData } from '../custom/op-alarm-data'

export class OpAlarm implements IOpObject, IReferenceType, IOpChangeState {
    //Properties
    public idAlarm: number
    public idAlarmEvent: number
    public idAlarmDef: number
    public serialNbr: number
    public idMeter: number
    public idLocation: number
    public idAlarmType: number
    public idDataTypeAlarm: number
    public systemAlarmValue: any
    public alarmValue: any
    public idOperator: number
    public idAlarmStatus: number
    public idTransmissionType: number
    public idAlarmGroup: number
    //Properties end
    //NavigationProperties
    public location: OpLocation
    public meter: OpMeter
    public device: OpDevice
    public alarmType: OpAlarmType
    public alarmStatus: OpAlarmStatus
    public operator: OpOperator
    public transmissionType: OpTransmissionType
    //NavigationProperties end
    //CustomProperties
    public alarmMessage: OpAlarmMessage
    public events: OpAlarm[]
    //CustomProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdAlarm
    }
    public getReferenceKey(): number {
        return this.idAlarm
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end
    //IOpObject implementation
    public get idObject(): any {
        return this.idAlarm
    }
    public set idObject(idObject: any) {
        this.idAlarm = idObject
    }

    public dataList: OpDataList<OpAlarmData> = new OpDataList<OpAlarmData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        this.idAlarm = opObj.ID_ALARM
        this.idAlarmEvent = opObj.ID_ALARM_EVENT
        this.idAlarmDef = opObj.ID_ALARM_DEF
        this.serialNbr = opObj.SERIAL_NBR
        this.idMeter = opObj.ID_METER
        this.idLocation = opObj.ID_LOCATION
        this.idAlarmType = opObj.ID_ALARM_TYPE
        this.idDataTypeAlarm = opObj.ID_DATA_TYPE_ALARM
        this.systemAlarmValue = opObj.SYSTEM_ALARM_VALUE
        this.alarmValue = opObj.ALARM_VALUE
        this.idOperator = opObj.ID_OPERATOR
        this.idAlarmStatus = opObj.ID_ALARM_STATUS
        this.idTransmissionType = opObj.ID_TRANSMISSION_TYPE
        this.idAlarmGroup = opObj.ID_ALARM_GROUP

        if (opObj.DataList)
            this.dataList.push(...opObj.DataList.map(data => new OpAlarmData(data)))
        else
            this.dataList = new OpDataList<OpAlarmData>()

        if (opObj.AlarmMessage)
            this.alarmMessage = new OpAlarmMessage(opObj.AlarmMessage)
        if (opObj._Location)
            this.location = new OpLocation(opObj._Location)
        if (opObj._Meter)
            this.meter = new OpMeter(opObj._Meter)
        if (opObj._Device)
            this.device = new OpDevice(opObj._Device)
        if (opObj._AlarmType)
            this.alarmType = new OpAlarmType(opObj._AlarmType)
        if (opObj._AlarmStatus)
            this.alarmStatus = new OpAlarmStatus(opObj._AlarmStatus)
        if (opObj._Operator)
            this.operator = new OpOperator(opObj._Operator)
        if (opObj._TransmissionType)
            this.transmissionType = new OpTransmissionType(opObj._TransmissionType)

        if (opObj.Events)
            this.events = opObj.Events.map(e => { return new OpAlarm(e) })
        else
            this.events = []

        this.opState = opObj.OpState
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM: this.idAlarm,
            ID_ALARM_EVENT: this.idAlarmEvent,
            ID_ALARM_DEF: this.idAlarmDef,
            SERIAL_NBR: this.serialNbr,
            ID_METER: this.idMeter,
            ID_LOCATION: this.idLocation,
            ID_ALARM_TYPE: this.idAlarmType,
            ID_DATA_TYPE_ALARM: this.idDataTypeAlarm,
            SYSTEM_ALARM_VALUE: this.systemAlarmValue,
            ALARM_VALUE: this.alarmValue,
            ID_OPERATOR: this.idOperator,
            ID_ALARM_STATUS: this.idAlarmStatus,
            ID_TRANSMISSION_TYPE: this.idTransmissionType,
            ID_ALARM_GROUP: this.idAlarmGroup,
            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState
        }
    }
    
    public toString() {
        var customFormatString = ObjectCustomString.getCustomStringFormat(this)
        if (!customFormatString) {
            if (this.transmissionType)
                return this.transmissionType.toString()
            return "Alarm [" + this.idAlarm + "]"
        }
        else {
            return ObjectCustomString.getObjectCustomString(customFormatString, this)
        }
    }
    //IOpObject implementation end
}